/*
 * Copyright (c) 2021 OTB Africa. All rights reserved. <https://otbafrica.com>
 *
 * Created Date: Tuesday, January 24th 2023, 12:34:41 pm
 * Author: OTB Africa, developers@otbafrica.com
 *
 * Use of this source code is governed by the license that can be found in
 * the LICENSE file or at https://developers.otbafrica.com/licenses/
 */

import { ProcessDefinition } from "lib/schemas";
import { COLORSCHEME } from "theme/styles";

type IStatusUIProperties = Record<
  ProcessDefinition["status"] | "DEFAULT",
  {
    color: string;
    label: "Development" | "Testing" | "Live";
  }
>;

export const StatusUIProperties: IStatusUIProperties = {
  DEVELOPMENT: {
    color: COLORSCHEME.secondary,
    label: "Development",
  },
  PRE_DEPLOYMENT_TESTING: {
    color: COLORSCHEME.info,
    label: "Testing",
  },
  DEPLOYED: {
    color: COLORSCHEME.success,
    label: "Live",
  },
  DEFAULT: {
    color: COLORSCHEME.onPrimary,
    label: null,
  },
};
